<script>
  export let data;
  export let small = false;
  export let largeMobTitle = false;
</script>

<div class="block-title text-center">
  {#if data.title}
    <h2 class="h3" class:large-title={largeMobTitle}>{@html data.title}</h2>
  {/if}
  {#if data.desc}
    <p class="block-title__desc" class:text-small={small}>{@html data.desc}</p>
  {/if}
</div>

<style lang="scss">
  .block-title {
    h2.large-title {
      @include resp-max('s') {
        @include h2;
        line-height: 1.32;
      }
    }
    max-width: 78rem;
    margin: 0 auto;

    &__desc {
      color: var(--royal-light);
      margin: 1.8rem auto 0;

      &.text-small {
        max-width: 40rem;
        margin-top: 1rem;
      }
    }
  }
</style>
